import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=38599706&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=38599706&prod&scoped=true&lang=scss"
import style1 from "./BaseLayout.vue?vue&type=style&index=1&id=38599706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38599706",
  null
  
)

export default component.exports